import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { showMessage } from "../../../utils/toast/globalToast";
import { _toastVariants } from "../../../utils/Constant";
import { changePassword } from "../../../action/userAction";

const ChangePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string().required("Old password is required."),
  newPassword: Yup.string()
    .min(6, "Password must be at least 6 characters.")
    .required("New password is required."),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords do not match.")
    .required("Please confirm your new password."),
});

const ChangePassword = () => {
  const [showPassword, setShowPassword] = useState({
    old: false,
    new: false,
    confirm: false,
  });

  const togglePassword = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSubmit = async (values, { resetForm, setSubmitting }) => {
    try {
      const payload = {
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
      };

      const response = await changePassword(payload);

      if (response && response.success === true) {
        showMessage(response.message, _toastVariants.Success);
        resetForm();
      } else {
        const errMsg = response?.error;
        showMessage(errMsg, _toastVariants.Error);
      }
    } catch (error) {
      console.error("Error changing password:", error);
      showMessage("Something went wrong. Please try again.", _toastVariants.Error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="content mb-5">
      <div className="container-fluid">
        <div className="row titlepad publsih-sticky">
          <div className="col-md-12">
            <div className="mt-3 mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>
            <div className="row">
              <div className="col-sm-8">
                <h4>Change Password</h4>
              </div>
              <div className="col-md-4 text-sm-right mt-2">
                <button
                  type="submit"
                  form="changePasswordForm"
                  className="btn-md px-3 py-2 btn-primary"
                >
                  <i className="fa fa-check-square-o"></i> Save
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-6">
            <Formik
              initialValues={{
                oldPassword: "",
                newPassword: "",
                confirmPassword: "",
              }}
              validationSchema={ChangePasswordSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form id="changePasswordForm">
                  <div className="form-group mb-3">
                    <label className="font-weight-bold">Old Password</label>
                    <div className="input-with-icon">
                      <Field
                        type={showPassword.old ? "text" : "password"}
                        name="oldPassword"
                        placeholder="Enter your old password"
                        className="form-control custom-input-width"
                      />
                      <i
                        className={`fa ${
                          showPassword.old ? "fa-eye-slash" : "fa-eye"
                        } icon-eye`}
                        onClick={() => togglePassword("old")}
                      ></i>
                      <ErrorMessage
                        name="oldPassword"
                        component="div"
                        className="invalid-feedback d-block"
                      />
                    </div>
                  </div>

                  <div className="form-group mb-3">
                    <label className="font-weight-bold">New Password</label>
                    <div className="input-with-icon">
                      <Field
                        type={showPassword.new ? "text" : "password"}
                        name="newPassword"
                        placeholder="Enter new password"
                        className="form-control custom-input-width"
                      />
                      <i
                        className={`fa ${
                          showPassword.new ? "fa-eye-slash" : "fa-eye"
                        } icon-eye`}
                        onClick={() => togglePassword("new")}
                      ></i>
                      <ErrorMessage
                        name="newPassword"
                        component="div"
                        className="invalid-feedback d-block"
                      />
                    </div>
                  </div>

                  <div className="form-group mb-4">
                    <label className="font-weight-bold">Confirm Password</label>
                    <div className="input-with-icon">
                      <Field
                        type={showPassword.confirm ? "text" : "password"}
                        name="confirmPassword"
                        placeholder="Confirm new password"
                        className="form-control custom-input-width"
                      />
                      <i
                        className={`fa ${
                          showPassword.confirm ? "fa-eye-slash" : "fa-eye"
                        } icon-eye`}
                        onClick={() => togglePassword("confirm")}
                      ></i>
                      <ErrorMessage
                        name="confirmPassword"
                        component="div"
                        className="invalid-feedback d-block"
                      />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChangePassword;
